export default __webpack_public_path__ + "static/yamakawa-full-34eecdf474b412b7dbd91edd1e9e7858.png";